import { render, staticRenderFns } from "./VipPayModal.vue?vue&type=template&id=5b049071&scoped=true"
import script from "./VipPayModal.vue?vue&type=script&lang=js"
export * from "./VipPayModal.vue?vue&type=script&lang=js"
import style0 from "./VipPayModal.vue?vue&type=style&index=0&id=5b049071&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b049071",
  null
  
)

export default component.exports